
export class BaseEventListener
{
    constructor(){
        this.listenersMap = new Map();
    }

    _broadcastEvent (event) {
        const listeners = this.listenersMap.get(event.type);
        // console.log("broadcasting event", event, "listeners", listeners);
        if(listeners){
            listeners.forEach(listener =>{
                listener(event);
            });
        }
    }

    addEventListener(eventType, listener){
        if(!eventType) return;

        // console.log("adding event", eventType, listener);
        if(this.listenersMap.get(eventType)){
            this.listenersMap.get(eventType).push(listener);
        }else{
            // console.log("creating type", eventType);
            this.listenersMap.set(eventType, [listener]);
        }
    }
    
    removeEventListener(eventType, listener) {
        if(!eventType) return;

        if(this.listenersMap.get(eventType)){
            let listeners = this.listenersMap.get(eventType);
            // console.log("removing event listener of type", eventType, "before size", listeners.length);
            const index = listeners.indexOf(listener);
            if (index >= 0) {
                listeners.splice(index, 1);
            }
            // console.log("removing event listener of type", eventType, "after size", this.listenersMap.get(eventType).length);
        }
    }

    provide(eventType, value) {
        const event = {
            type: eventType,
            value,
        };
        this._broadcastEvent(event);
    }
}
